module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CpfBNk/tc-custom/9781398496132.jpg?1705766095498",
      "alt": "This image is the cover for the book Fucking Pterodactyl"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fucking Pterodactyl\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Margareta du Plessis the Republican Madam Prime Minister does “Madam Prime Minister’s Questions” as she takes a few swipes at her pterodactyl Democrat opposite by calling him a “fucking pterodactyl” over his sex allegations of her gay brother’s doings with a European male whore on live Gay TV the night before, by tossing her half-drunk glass of wine right at him where it just missed him by inches as it pulverized upon the olive-green work-bench right beside him. Madam Prime Minister also had a go at her pterodactyl counterpart over the acquisition of androids which work without any pay and don’t require any food, that are set to replace general biological office workers who she’s commissioned to immediately work in an Andromeda exotic jewellery mining colony for jewels to be made and sold intergalactically. So, the pterodactyl calls for immediate strikes in the House of Commons, London, circa 30,050 AD. in an alternate sci-fi reality.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Xenophon Oviduis-Sophron-Naso\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("As a stateless individual with spiritual inspiration, I’ve achieved both an excellent photographic background with some videography along with the editing sides as well. My professional background includes Advanced Photography, Advanced Graphic Design, Web Design and Advanced Web Development.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0